import script from "./Notice.vue?vue&type=script&setup=true&lang=js"
export * from "./Notice.vue?vue&type=script&setup=true&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=796487fd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796487fd"]])

export default __exports__